import { render, staticRenderFns } from "./BlockHead.vue?vue&type=template&id=0f1827c8&"
import script from "./BlockHead.vue?vue&type=script&lang=js&"
export * from "./BlockHead.vue?vue&type=script&lang=js&"
import style0 from "./BlockHead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports